import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IrrigationData } from './irrigation-data.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IrrigationDataService {
  private apiUrl = environment.syncServiceBaseUrl + 'irrigation/stats';

  constructor(private http: HttpClient) { }

  getIrrigationStats(fromDate: string, toDate: string, fieldId: number): Observable<IrrigationData[]> {
    const params = new HttpParams()
      .set('fromDate', fromDate)
      .set('toDate', toDate)
      .set('fieldId', fieldId.toString());

    return this.http.get<IrrigationData[]>(this.apiUrl, { params });
  }
}
